import { useWhereabouts } from '@rexlabs/whereabouts';

export function useAppId() {
  const { query } = useWhereabouts();
  return query?.app_id || 'rex';
}
